import { render, staticRenderFns } from "./SchoolEstablishmentsAdd.vue?vue&type=template&id=74cf9032"
import script from "./SchoolEstablishmentsAdd.vue?vue&type=script&lang=js"
export * from "./SchoolEstablishmentsAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports